import { Route, Routes, useNavigate } from 'react-router-dom';
import { Security, LoginCallback } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import Home from './pages/Home';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import { getOktaAuth } from './providers/AuthProvider';
import { getConfig } from './providers/ConfigProvider';
import { RequireAuth } from './components/atoms/RequireAuth';
import './App.css';
import Header from './components/organisms/Header';

const App = () => {
  const oktaAuth = getOktaAuth();
  const nav = useNavigate();
  const handleOnCancel = () => nav('/login', { replace: true });

  const onAuthRequired = () => {
    nav('/login', { replace: true });
  };

  const restoreOriginalUri = (_: any, originalUri: string) => {
    const URI = originalUri ?? '/';
    const basePath = getConfig().REACT_APP_BASE_PATH;

    nav(
      toRelativeUrl(
        URI.replace(basePath, ''),
        `${window.location.origin}${basePath}`,
      ),
      { replace: true },
    );
  };

  return (
    <div className="App">
      <Security
        oktaAuth={oktaAuth}
        onAuthRequired={onAuthRequired}
        restoreOriginalUri={restoreOriginalUri}>
        <Header />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/login/callback" element={<LoginCallback />} />
          <Route path="/resetpassword" element={<ResetPassword />} />
          <Route
            path="*"
            element={
              <RequireAuth>
                <Home />
              </RequireAuth>
            }
          />
        </Routes>
      </Security>
    </div>
  );
};

export default App;
